<div class="container-fluid glb-popup">
  @if (formLoading) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="m-0">

        <div class="max-width-200px">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="max-width-200px mb-3">
          <span class="p-float-label required-field w-100">
            <input formControlName="accessCode" id="accessCode" type="text" pInputText>
            <label for="accessCode">Access Code&nbsp;<span class="text-danger">*</span></label>
          </span>
          @for (validation of validationMessages.accessCode; track validation) {
            <span>
              @if (form1.get('accessCode').hasError(validation.type) && (form1.get('accessCode').dirty || form1.get('accessCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

        <div class="d-flex gap-2 align-items-start mb-3">
          <div class="flex-fill">
            <span class="p-float-label w-100">
              <p-calendar
                [readonlyInput]="true"
                [minDate]="startMinDate"
                (onSelect)="onStartDatePartSelect($event)"
                formControlName="startDatePart"
                inputId="startDatePart">
              </p-calendar>
              <label for="startDatePart">Start Date&nbsp;<span class="text-danger">*</span></label>
            </span>
            @for (validation of validationMessages.startDatePart; track validation) {
              <span>
                @if (form1.get('startDatePart').hasError(validation.type) && (form1.get('startDatePart').dirty || form1.get('startDatePart').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
          <div class="flex-fill">
            <span class="p-float-label w-100">
              <p-calendar
                [timeOnly]="true"
                [hourFormat]="12"
                formControlName="startTimePart"
                inputId="startTimePart">
              </p-calendar>
              <label for="startTimePart">Start Time</label>
            </span>
          </div>
        </div>

        <div class="d-flex gap-2 align-items-start mb-3">
          <div class="flex-fill">
            <span class="p-float-label w-100">
              <p-calendar
                [readonlyInput]="true"
                [minDate]="endMinDate"
                formControlName="endDatePart"
                inputId="endDatePart">
              </p-calendar>
              <label for="endDatePart">End Date&nbsp;<span class="text-danger">*</span></label>
            </span>
            @for (validation of validationMessages.endDatePart; track validation) {
              <span>
                @if (form1.get('endDatePart').hasError(validation.type) && (form1.get('endDatePart').dirty || form1.get('endDatePart').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </div>
          <div class="flex-fill">
            <span class="p-float-label w-100">
              <p-calendar
                [timeOnly]="true"
                [hourFormat]="12"
                formControlName="endTimePart"
                inputId="endTimePart">
              </p-calendar>
              <label for="endTimePart">End Time</label>
            </span>
          </div>
        </div>

        <!-- Lock Location -->
        <div class="max-width-200px mb-3">
          <span class="p-float-label w-100">
            <p-dropdown
              [filter]="true"
              dropdownIcon="fa fa-caret-down"
              class="w-100"
              [options]="lockLocations"
              formControlName="lockLocation"
              optionLabel="name"
              optionValue="value"
              placeholder="Lock Location">
            </p-dropdown>
            <label for="lockLocation">Lock Location</label>
          </span>
          @for (validation of validationMessages.lockLocation; track validation) {
            <span>
              @if (form1.get('lockLocation').hasError(validation.type) && (form1.get('lockLocation').dirty || form1.get('lockLocation').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </div>

        <!-- <div class="max-width-200px">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="doorName" class="disabled" readonly="true" id="doorName" type="text" pInputText>
          <label for="doorName">Door Name</label>
          <span *ngFor="let validation of validationMessages.doorName">
            <small class="p-invalid"
              *ngIf="form1.get('doorName').hasError(validation.type) && (form1.get('doorName').dirty || form1.get('doorName').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->

      <div class="max-width-200px">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown [filter]="true" dropdownIcon="fa fa-caret-down" class="w-100" [options]="accessTypes" formControlName="accessType" optionLabel="name"
          optionValue="value" placeholder="Access Type"></p-dropdown>
          <label for="accessType">Access Type</label>
          @for (validation of validationMessages.accessType; track validation) {
            <span>
              @if (form1.get('accessType').hasError(validation.type) && (form1.get('accessType').dirty || form1.get('accessType').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <!-- <div class="max-width-200px">
      <span class="p-float-label w-100 mb-3">
        <p-dropdown [filter]="true" class="disabled" readonly="true" dropdownIcon="fa fa-caret-down" class="w-100" [options]="accessStatuses" formControlName="kabaStatus" optionLabel="name"
        optionValue="value" placeholder="Access Type"></p-dropdown>
        <label for="kabaStatus">Kaba Status</label>
        <span *ngFor="let validation of validationMessages.kabaStatus">
          <small class="p-invalid"
            *ngIf="form1.get('kabaStatus').hasError(validation.type) && (form1.get('kabaStatus').dirty || form1.get('kabaStatus').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div>

    <div>
      <span class="p-float-label required-field w-100 mb-3">
        <textarea formControlName="logger" id="logger" class="disabled" readonly="true" pInputTextarea rows="3"></textarea>
        <label for="logger">Logger</label>
        <span *ngFor="let validation of validationMessages.logger">
          <small class="p-invalid"
            *ngIf="form1.get('logger').hasError(validation.type) && (form1.get('logger').dirty || form1.get('logger').touched)">{{validation.message}}
          </small>
        </span>
      </span>
    </div> -->

  </div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (accessCodeId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            [disabled]="formLoading" (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [disabled]="formLoading" [mat-dialog-close]="formLoading ? null : true">Cancel</button>
          @if (!accessCodeId) {
            <button pButton class="btn-addt p-button" [disabled]="formLoading" (click)="formAdd()">
              @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Add
            </button>
          }

          @if (accessCodeId) {
            <button pButton class="btn-upt p-button" [disabled]="formLoading" (click)="formUpdate()">
              @if (formLoading) { <i class="pi pi-spin pi-spinner mr-1"></i> } Update
            </button>
          }
        </div>
      </div>
    </div>
  </div>
</div>
